/* eslint-disable @angular-eslint/component-class-suffix */
import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { SafeResourceUrl } from '@angular/platform-browser';
import { TrainingVideoService } from '../../services/training-video.service';

@Component({
    selector: 'oz-training-video-dialog',
    templateUrl: 'training-video-dialog.html',
    standalone: true,
    imports: [MatDialogModule, MatButtonModule, MatCheckboxModule, FormsModule],
    styles: [`
        .video-container {
            position: relative;
            width: 100%;
            max-width: 350px;
            margin: 0 auto;
            aspect-ratio: 9 / 16;
            background: #000;
            border-radius: 8px;
            overflow: hidden;
        }

        .video-container iframe {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: none;
        }

        .dont-show-checkbox {
            margin-top: 16px;
        }

        @media (max-width: 480px) {
            .video-container {
                max-width: 280px;
            }
        }
    `]
})
export class TrainingVideoDialog implements OnInit {

    private readonly dialogRef = inject(MatDialogRef<TrainingVideoDialog>);
    private readonly trainingVideoService = inject(TrainingVideoService);

    public videoUrl: SafeResourceUrl | undefined;
    public dontShowAgain = false;

    public ngOnInit(): void {
        this.videoUrl = this.trainingVideoService.getYouTubeEmbedUrl('intro');
        this.trainingVideoService.recordVideoShown();
        this.trainingVideoService.recordLogin();
    }

    public onClose(): void {
        if (this.dontShowAgain) {
            this.trainingVideoService.dismissVideo('intro');
        }
        this.dialogRef.close();
    }
}
